<template>
    <div class="mv_category" @click="$router.push('/category/' + cat.id)" >
        <div id="mv_category_text" ref="cat" ><h5>{{cat.name}}</h5></div>
        <img ref="catImage" :src="(cat.images && cat.images.length > 0 && cat.images.find(x => x.primary) ? './api/Image/Get/'+ cat.images.find(x => x.primary).id : './cat_placeholder.jpg')" id="mv_category_bg">
    </div>
</template>

<script>
import FastAverageColor from 'fast-average-color';
import Color from 'color';
export default {
    props: ['cat'],
    mounted () {
        let avgColor = new FastAverageColor();
        avgColor.getColorAsync(this.$refs.catImage).then((c) => {
            let color = Color(c.hex)
          
            this.$refs.cat.style.backgroundColor =  color.darken(0.2).fade(0.1)
            
        })
    }
}
</script>
<style lang="scss" scoped>
  @import '@/styles/variables.scss';

 .mv_category {
      display: inline-flex;
      align-items: flex-end;
      position: relative;
      box-sizing:border-box;padding: 1em;
      
      width: 100%;
      height: 155px;
      background-color: #DDD;
      background-size: cover;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: $radius;
      overflow: hidden;
      h5 {
          font-size: 1.2em;
          margin: .5em 0;
          z-index: 1;
      }
      transition: .3s cubic-bezier(0.19, 1, 0.22, 1);
    #mv_category_text {
        width: 100%;
        bottom:0;
        left: 0;
        background-color: transparentize($color: #929BA3, $amount: .2);
        position: absolute;
        z-index: 1;
        color: white;
        box-sizing:border-box;padding: .5em;
    }
    #mv_category_bg {
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
    }
  }
</style>